import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '功能介绍', path: '/article/aiye-video-app-gongneng-xiangjie' },
      { label: '下载安装', path: '/article/aiye-video-app-xiazai-anjiao' },
      { label: '会员权益', path: '/article/aiye-video-app-huiyuan-quanyi' },
      { label: '版本更新', path: '/' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '使用技巧', path: '/article/aiye-video-app-shiyong-jiqiao' },
      { label: '常见问题', path: '/article/aiye-video-app-changjian-wenti' },
      { label: '安装帮助', path: '/article/aiye-video-app-anzhuo-anzhuang' },
      { label: '意见反馈', path: '/about' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '用户协议', path: '/' },
      { label: '隐私政策', path: '/' },
    ],
  },
  categories: {
    title: '热门分类',
    links: [
      { label: '热门推荐', path: '/category/remen-tuijian' },
      { label: '综艺娱乐', path: '/category/zongyi-yule' },
      { label: '电影剧场', path: '/category/dianying-juchang' },
      { label: '电视剧集', path: '/category/dianshiju' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-foreground-950 font-heading font-semibold text-sm mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-500 hover:text-primary-600 text-sm transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-foreground-600 text-sm">
            <span className="w-6 h-6 flex items-center justify-center bg-primary-500 text-background-50 rounded-md text-xs">
              <i className="ri-play-circle-fill text-xs"></i>
            </span>
            <span>&copy; 2019 - 2025 爱液视频 版权所有</span>
          </div>
          <div className="flex items-center gap-4 text-foreground-400 text-sm">
            <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">
              粤ICP备2025XXXXXX号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}